import { Checkbox, CheckboxProps } from '@optimus-web/core';

interface BulkCheckboxProps extends Omit<CheckboxProps, 'checked' | 'indeterminate'> {
    allSelected: boolean;
    someSelected: boolean;
}

export const BulkCheckbox: React.FC<BulkCheckboxProps> = ({ allSelected, someSelected, onChange, ...other }) => {
    const handleChange: CheckboxProps['onChange'] = (e, checked) => {
        e.stopPropagation();
        onChange?.(e, checked);
    };
    return (
        <Checkbox
            checked={someSelected}
            indeterminate={someSelected && !allSelected}
            onChange={handleChange}
            {...other}
        />
    );
};
